<script setup lang="ts">
const emits = defineEmits(['next'])
</script>

<template>
  <button class="text-brand-white" @click.stop="emits('next')">
    <Icon name="material-symbols:chevron-right-rounded" size="50" />
  </button>
</template>
